import React, { useState} from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Button, Modal, Form } from "react-bootstrap";

import Select from 'react-select';

import {
  loadSitesOnTestStart,
  loadSitesOnTestCountStart,
} from "services/redux/actions/sitesOnTest";

import { getEnterpriseFromRoute } from "services/redux/selectors/enterprises";
import { getGroupFromRoute } from "services/redux/selectors/groups";
import { getSites } from "services/redux/selectors";
import { getSiteOptions } from "services/redux/selectors/customReports";

import Alert from "components/Common/Alert";

import Loading from "components/Loading";

import conxtdOut from "apis/conxtdOut";

import "./PutSiteOnTestModal.scss";

import find from "lodash/find";
import get from "lodash/get";

function PutSiteOnTestModal(props) {
  const dispatch = useDispatch();

  const [selectedSite, setSelectedSite] = useState(null);
  const [selectedSiteOption, setSelectedSiteOption] = useState(null);
  const [saving, setSaving] = useState(false);

  const enterprise = useSelector(getEnterpriseFromRoute);
  const group = useSelector(getGroupFromRoute);
  const sites = useSelector(getSites);
  const siteOptions = useSelector(getSiteOptions);
  const pagination = useSelector(state => state.sitesOnTest.data.pagination);
  const sortField = useSelector(state => state.sitesOnTest.sortField);
  const sortDirection = useSelector(state => state.sitesOnTest.sortDirection);
  const filters = useSelector(state => state.sitesOnTest.filters);

  const enterpriseId = enterprise.id;
  const groupId = (group && group.id) || enterprise.root_group_id;

  const onHide = () => {
    setSelectedSite(null);
    setSelectedSiteOption(null);

    props.onHide();
  }

  return (
    <Modal
      show={props.show}
      onHide={onHide}
      aria-labelledby="contained-modal-title-vcenter"
      dialogClassName="modal-60w"
      centered
    >
      <Form
        id="site_on_test_form"
        onSubmit={(e) => {
          e.preventDefault();

          setSaving(true);

          const putSiteOnTest = conxtdOut.post(`/EnterpriseSites/enableTestMode/${selectedSite.id}`, {
            toggle: "en",
            // mode_password: e.target.password.value,
          });

          putSiteOnTest.then(() => {
            setSaving(false);
            // document.getElementById("site_on_test_password").value = null;

            dispatch(
              loadSitesOnTestStart({ 
                enterprise_id: enterpriseId,
                group_id: groupId,
                pageSize: pagination.perPage,
                requestPageNumber: pagination.requestPage,
                sortField: sortField,
                sortDirection: sortDirection,
                filters: filters,
              })
            );

            dispatch(
              loadSitesOnTestCountStart({
                enterprise_id: enterpriseId,
                group_id: groupId, 
              })
            )

            Alert({
              text: "Site has been put on test.",
              icon: "success",
              timerProgressBar: true,
              timer: 3000,
            });
            
          }).catch((error) => {
            setSaving(false);
            // document.getElementById("site_on_test_password").value = null;

            const status = get(error.response, "status");
            
            let messageText = "Issue putting site on test. Please try again later.";
            // 422 unprocessable
            if (status === 422 && error.response.data && error.response.data.message) {
              messageText = error.response.data.message;
            }

            Alert({
              text: messageText,
              icon: "warning",
              showConfirmButton: true,
            });
          });
        }
      }>
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Put Site On Test
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div
            className="d-flex flex-column justify-content-between"
            style={{ minHeight: "420px" }}
          >
            <div>
              <Form.Label>Select Site</Form.Label>
              <Select
                options={siteOptions}
                value={selectedSiteOption}
                name="selected_site"
                classNamePrefix="selected-site-select"
                maxMenuHeight={290}
                // isClearable={true}
                onChange={(e) => {
                  const selectedSiteOption = e ? find(siteOptions, ['value', e.value]) : null;
                  const selectedSite = selectedSiteOption ? find(sites, ['id', selectedSiteOption.value]) : null;
                  setSelectedSiteOption(selectedSiteOption);
                  setSelectedSite(selectedSite);
                }}
              />
              <div className="p-2 mt-1">
                <Form.Label className="mb-1">Address</Form.Label>
                <div>{selectedSite && selectedSite.address1}</div>
                <div>{selectedSite && selectedSite.address2}</div>
                <div>{selectedSite && selectedSite.town}</div>
                <div>{selectedSite && selectedSite.postcode}</div>
              </div>
              {
                selectedSite && selectedSite.site_fields && selectedSite.site_fields.length > 0
                  ? <div className="p-2">
                      <Form.Label className="mb-1">Custom Fields</Form.Label>
                      {selectedSite.site_fields.map((siteField) => {
                        return <div>
                          <span className="float-left col-4" style={{paddingLeft: "0"}}>{siteField.enterprise_user_field && siteField.enterprise_user_field.name + ":"}</span>
                          <span className="float-right col-8" style={{paddingLeft: "0"}}>{siteField.value}</span>
                        </div>
                      })}
                    </div>
                  : null
              }
              {/* <div>
                <Form.Label>Password</Form.Label>
                <Form.Control
                  id="site_on_test_password"
                  name="password"
                  component="input"
                  type="password"
                  placeholder="Enter password"
                  required={true}
                />
              </div> */}
              {/* <div className="d-flex justify-content-end mt-3">
                <div className="d-flex align-items-center">
                  { saving && <Loading /> }
                  <Button
                    className="p-2 ml-2"
                    style={{backgroundColor: "#8e44ad", border: "1px solid #8e44ad"}}
                    type="submit"
                    disabled={saving || !selectedSiteOption}
                  >
                    Put Site On Test
                  </Button>
                </div>
              </div> */}
              </div>
              <div>
                <div className="site-on-test-warning">
                  This feature will temporarily suppress all alarms for site from all areas of CONXTD including Priority Events, Reports and outbound notifications. Test period will automatically end after 4 hours but can be manually ended at any point.
                </div>
                <div
                  className="d-flex justify-content-end"
                >
                  <Button
                    className="p-2 ml-2"
                    style={{backgroundColor: "#8e44ad", border: "1px solid #8e44ad", width: "122px"}}
                    type="submit"
                    disabled={saving || !selectedSiteOption}
                  >
                    {saving ? <Loading /> : "Put Site On Test"}
                  </Button>
                </div>
              </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="container">
            <div className="d-flex justify-content-end">
              <Button
                className="p-2"
                variant="primary"
                style={{minWidth: "70px"}}
                onClick={() => onHide()}
              >
                Close
              </Button>
            </div>
          </div>
        </Modal.Footer>
      </Form>
    </Modal>
  )
}

export default PutSiteOnTestModal;